// extracted by mini-css-extract-plugin
export default {"name":"Header_name__61vHh","code":"Header_code__tuSv+","item":"Header_item__GJfwK"};